import * as Sqrl from 'squirrelly';
export default ()=>{
    basketHandle();

    function getCart(mainCart) {

        setTimeout(function(){
          fetch('/cart.js')
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              let cart = data;
              if (mainCart){
                  basketLoading(false);
                  buildMainCart(cart)
              }
              renderMenuCart(cart);
            });
        }, 400);
    }
    window.gc = getCart;

    function setCounter(cart) {
        let counterVal = document.querySelector('.cart-count');
        const HIDDEN_CLASS = 'cart-count--hidden';
    
        let total = cart.item_count;
    
        if (counterVal) {
            counterVal.innerText = total || -1;
            if (total === 0 ) {
                counterVal.classList.add(HIDDEN_CLASS);
            } else {
                counterVal.classList.remove(HIDDEN_CLASS);
            }
        }
    }


    getCart();

    function renderMenuCart(cart) {
        let target = document.querySelector('.small-basket-list');
        let curr = target.dataset.currency;
        let myTemplate = `
        {{@if(it.c.items.length === 0)}}
            <li class="small-basket-item empty-basket">Basket is Empty</li>
        {{#else}}
            {{@each(it.c.items) => item, index}}
                <li class="small-basket-item">
                    <div class="small-basket-item__img-wrap">
                        <img src="{{item.image}}" alt="image" class="item-img">
                    </div>
                    <div class="item-text-wrapper">
                        <h4 class="item-name">
                            <a href="{{item.url}}">
                                <p>{{item.title}}</p>     
                            </a>
                        </h4>
                        
                        <p class="item-price">${curr}{{item.final_line_price/100}}</p>
                        
                        <form method="post" class="item-remove" action="/cart/change?line={{index+1}}&quantity=0" onSubmit="">
                            <input type="hidden" name="return_to" value="back" />
                            <button type="submit">remove</button>
                        </form>
                    </div>
                </li>
            {{/each}}
        {{/if}}

            `;

        let result = Sqrl.render(myTemplate, {
            c: cart
        });

        target?target.innerHTML = result:false;
        
        setCounter(cart);
    }
     
    async function addToCart(id, quantity, e) {
        let data = {
            items: [
                {
                    quantity: quantity,
                    id: id
                }
            ]
        };
        let response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(data)
        });
        
        let notify = document.querySelectorAll('.product-actions__add');
    
        if (response.status === 200) {
            let result = await response.json();
            gc(true);
            setTimeout(function(){
            }, 1500);
    
            if (notify.length) {
                notify.forEach(function(notifyEl) {
                    notifyEl.innerHTML = 'item added to cart';
        
                    setTimeout(function(){
                        notifyEl.innerHTML = 'add to basket';
                    }, 5000);
                });
            
            }
    
        } else if (response.status === 422) {
            if (notify.length) {
                notify.forEach(function(notifyEl) {
                    notifyEl.innerHTML = 'Out of stock';
                    notifyEl.setAttribute('disabled', true)
                });
            }
            
        } else {
        }
    }

    window.ac = addToCart;


    const basketMain = document.querySelector('.basket-full');
    
   
    async function deleteItem(line, e){
        basketLoading(true);
        let data = {
            quantity: 0,
            line: line
        };
        let response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(data)
        });
        if (response.status === 200) {
            let result = await response.json();
            getCart(true);
            setTimeout(function(){
            }, 1500);
        }
    }
    async function changeQuantity(line,quantity, e){

        basketLoading(true);

        let data = {
            quantity: quantity,
            line: line
        };
        let response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(data)
        });
        if (response.status === 200) {
            let result = await response.json();
            getCart(true);
            setTimeout(function(){
            }, 1500);                  
        } else {
            basketLoading(false);
        }
    }

    function basketLoading(state) {
        const container = document.querySelector('.basket-container');
        const LOADING_CLASS = 'basket-container--disabled';

        if (container) {
            if (state) {
                container.classList.add(LOADING_CLASS);
            } else {
                container.classList.remove(LOADING_CLASS);
            }
        }
    }

    productHandle();

    function productHandle(){
        if (basketMain){
            const lines = basketMain.querySelectorAll('.basket-item');

            lines.forEach(line =>{
                const delButton = line.querySelector('.trash');
                const lineIndex = delButton.dataset.line;
                const changeQuant = line.querySelectorAll('[data-change-quant]');
                const delDesktopButton = line.querySelector('.trash-desktop')

                changeQuant.forEach(button =>{
                    const quant = button.dataset.quantity;
                    const lineInd = button.dataset.line;
                    button.addEventListener('click', () =>{
                        changeQuantity(lineInd, quant);
                    })
                    
                })
    
                delButton.addEventListener('click', () =>{
                    deleteItem(lineIndex);
                })
                delDesktopButton.addEventListener('click', () =>{
                    deleteItem(lineIndex);
                })
            })
        }
        
    }

    function buildMainCart(cart){
        let tar = document.querySelector('.basket-render');

        const currency = basketMain.dataset.currency;
       

        let myTemp = `
        {{@if(it.c.items.length === 0)}}
            <p class="basket-wrapper__empty">Your cart is empty, <a title="" href="/collections/">Go shopping</a></p>
        {{#else}}
            <div class="basket-shop-list-wrapper">
                <div class="basket-description-wrapper">
                    <ul class="description-list">
                        <li>Item</li>
                        <li>Size</li>
                        <li>Quantity</li>
                        <li>Price</li>
                    </ul>
                </div>
                <div class="basket-shop-list">
                    <div class="basket-description-mob">
                        <span> {{it.c.item_count }}
                            {{@if(it.c.item_count > 1)}}
                                items
                            {{#else}}
                                item
                            {{/if}}
                        </span>
                    </div>
                    
                    <ul class="basket-list">
                        {{@each(it.c.items) => item, ind}}

                            <li class="basket-item">
                                <div class="basket-item__inner">
                                    <div class="basket-item__img-wrap">
                                        <img src="{{ item.image }}"  alt="image" class="basket-item-img" />
                                    </div>
                                    <div class="basket-item__info-inner">
                                        <div class="basket-item-text">
                                            <h4>
                                                <a href="{{item.url}}"> 
                                                    
                                                    <p>{{item.product_title}}</p>     
                                                    
                                                </a>
                                            </h4>
                                            <button rel="{{ item.id }}"class='trash-desktop' data-line="{{ind}}">
                                                <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.99681 5.70518L8.48668 11.7517C8.46388 12.0224 8.87234 12.0594 8.8954 11.7862L9.40552 5.73966C9.41504 5.62682 9.33126 5.52761 9.21841 5.51807C9.10542 5.50856 9.0063 5.59231 8.99681 5.70518Z" fill="#484848"></path>
                                                    <path d="M4.31062 5.51782C4.19777 5.52736 4.11402 5.62656 4.12351 5.73941L4.63363 11.7859C4.65671 12.0594 5.06514 12.0221 5.04233 11.7514L4.53221 5.70493C4.52272 5.59206 4.42344 5.50836 4.31062 5.51782Z" fill="#484848"></path>
                                                    <path d="M6.55957 5.72229V11.7688C6.55957 11.8821 6.65136 11.9739 6.76465 11.9739C6.87793 11.9739 6.96973 11.8821 6.96973 11.7688V5.72229C6.96973 5.60903 6.87793 5.51721 6.76465 5.51721C6.65136 5.51721 6.55957 5.60903 6.55957 5.72229Z" fill="#484848"></path>
                                                    <path d="M11.9426 1.90683H8.71772V1.18602C8.71772 0.710023 8.33045 0.322754 7.85443 0.322754H5.67472C5.19872 0.322754 4.81145 0.710023 4.81145 1.18602V1.90683H1.58655C1.06497 1.90683 0.640625 2.33118 0.640625 2.85276C0.640625 3.37434 1.06497 3.79869 1.58655 3.79869H1.80714L2.57435 12.8922C2.64254 13.7004 3.31832 14.3228 4.13064 14.3228H9.39853C10.2096 14.3228 10.8865 13.7017 10.9548 12.8922L11.0612 11.6315C11.0707 11.5187 10.9869 11.4194 10.8741 11.4099C10.7609 11.4002 10.662 11.4841 10.6525 11.597L10.5461 12.8578C10.4962 13.4493 9.99213 13.9126 9.39853 13.9126H4.13064C3.53704 13.9126 3.03296 13.4493 2.98305 12.8578L2.21874 3.79869H2.82594C2.93922 3.79869 3.03102 3.70687 3.03102 3.59361C3.03102 3.48036 2.93922 3.38854 2.82594 3.38854C2.37671 3.38854 1.84698 3.38854 1.58655 3.38854C1.29113 3.38854 1.05078 3.14818 1.05078 2.85276C1.05078 2.55734 1.29113 2.31699 1.58655 2.31699H11.9426C12.238 2.31699 12.4784 2.55734 12.4784 2.85276C12.4784 3.14818 12.238 3.38854 11.9426 3.38854C11.6241 3.38854 4.474 3.38854 3.78524 3.38854C3.67195 3.38854 3.58016 3.48036 3.58016 3.59361C3.58016 3.70687 3.67195 3.79869 3.78524 3.79869H11.3104L10.7332 10.6402C10.7237 10.7531 10.8075 10.8523 10.9203 10.8618C10.9262 10.8623 10.932 10.8626 10.9378 10.8626C11.0433 10.8626 11.1329 10.7817 11.1419 10.6747L11.7221 3.79869H11.9426C12.4642 3.79869 12.8886 3.37434 12.8886 2.85276C12.8886 2.33118 12.4642 1.90683 11.9426 1.90683ZM8.30757 1.90683H5.22161V1.18602C5.22161 0.936184 5.42488 0.73291 5.67472 0.73291H7.85443C8.10429 0.73291 8.30754 0.936184 8.30754 1.18602V1.90683H8.30757Z" fill="#484848"></path>
                                                </svg>
                                            </button>
                                        </div>
                                        <span class="size">
                                            {{@if(item.variant_title.toLowerCase() == 'xx-large')}}
                                                XXL
                                            {{/if}} 
                                            {{@if(item.variant_title.toLowerCase() == 'x-large')}}
                                                XL
                                            {{/if}} 
                                            {{@if(item.variant_title.toLowerCase() == 'large')}}
                                                L
                                            {{/if}}
                                            {{@if(item.variant_title.toLowerCase() == 'medium')}}
                                                M
                                            {{/if}} 
                                            {{@if(item.variant_title.toLowerCase() == 'small')}}
                                                S
                                            {{/if}}
                                            {{@if(item.variant_title.toLowerCase() == 'x-small')}}
                                                XS
                                            {{/if}} 
                                            {{@if(item.variant_title.toLowerCase() == 'one size')}}
                                               ONE SIZE
                                            {{/if}}
                                        </span>
                                        <div class="quontity-wrapper">
                                           
                                            <button data-line="{{ ind + 1 }}" data-quantity="{{item.quantity - 1}}" data-change-quant class="decrease"  type="button" >
                                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5.47754" cy="5.81689" r="4.5" stroke="#484848"></circle>
                                                    <line x1="3.97754" y1="5.66602" x2="6.97754" y2="5.66602" stroke="#484848" stroke-linecap="round"></line>
                                                </svg>
                                            </button>
                                        
                                            <input name="quantity" value="{{item.quantity}}"/>
                                            
                                            <button data-line="{{ ind + 1 }}" data-quantity="{{item.quantity + 1}}" data-change-quant class="increase" type="button">
                                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5.47754" cy="5.81689" r="4.5" stroke="#484848"></circle>
                                                    <g clip-path="url(#clip0)">
                                                    <path d="M5.95721 5.33868L5.95727 3.66659C5.95727 3.40201 5.74282 3.18755 5.47831 3.18762C5.21393 3.18755 4.99934 3.40214 4.9994 3.66652L4.99947 5.33874L3.32725 5.33868C3.06287 5.33861 2.84828 5.5532 2.84835 5.81758C2.84835 6.08216 3.0628 6.29661 3.32732 6.29654L4.99934 6.29654L4.99934 7.96857C4.99934 8.23315 5.21379 8.4476 5.47831 8.44753C5.61053 8.44767 5.73029 8.39389 5.81692 8.30725C5.90349 8.22068 5.95734 8.10086 5.95721 7.96863L5.95727 6.29654H7.62943C7.76172 6.29661 7.88141 6.2429 7.96805 6.15626C8.05468 6.06963 8.10847 5.94987 8.10833 5.81764C8.10833 5.55306 7.89388 5.33861 7.62936 5.33868L5.95721 5.33868Z" fill="#484848"></path>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0">
                                                    <rect width="4" height="4" fill="white" transform="translate(2.64911 5.81714) rotate(-45)"></rect>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <span class="price">${currency}{{item.final_line_price/100}}</span>
                                <button rel="{{ item.id }}" class='trash' data-line="{{ ind + 1 }}" >
                                    <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.99681 5.70518L8.48668 11.7517C8.46388 12.0224 8.87234 12.0594 8.8954 11.7862L9.40552 5.73966C9.41504 5.62682 9.33126 5.52761 9.21841 5.51807C9.10542 5.50856 9.0063 5.59231 8.99681 5.70518Z" fill="#484848"></path>
                                        <path d="M4.31062 5.51782C4.19777 5.52736 4.11402 5.62656 4.12351 5.73941L4.63363 11.7859C4.65671 12.0594 5.06514 12.0221 5.04233 11.7514L4.53221 5.70493C4.52272 5.59206 4.42344 5.50836 4.31062 5.51782Z" fill="#484848"></path>
                                        <path d="M6.55957 5.72229V11.7688C6.55957 11.8821 6.65136 11.9739 6.76465 11.9739C6.87793 11.9739 6.96973 11.8821 6.96973 11.7688V5.72229C6.96973 5.60903 6.87793 5.51721 6.76465 5.51721C6.65136 5.51721 6.55957 5.60903 6.55957 5.72229Z" fill="#484848"></path>
                                        <path d="M11.9426 1.90683H8.71772V1.18602C8.71772 0.710023 8.33045 0.322754 7.85443 0.322754H5.67472C5.19872 0.322754 4.81145 0.710023 4.81145 1.18602V1.90683H1.58655C1.06497 1.90683 0.640625 2.33118 0.640625 2.85276C0.640625 3.37434 1.06497 3.79869 1.58655 3.79869H1.80714L2.57435 12.8922C2.64254 13.7004 3.31832 14.3228 4.13064 14.3228H9.39853C10.2096 14.3228 10.8865 13.7017 10.9548 12.8922L11.0612 11.6315C11.0707 11.5187 10.9869 11.4194 10.8741 11.4099C10.7609 11.4002 10.662 11.4841 10.6525 11.597L10.5461 12.8578C10.4962 13.4493 9.99213 13.9126 9.39853 13.9126H4.13064C3.53704 13.9126 3.03296 13.4493 2.98305 12.8578L2.21874 3.79869H2.82594C2.93922 3.79869 3.03102 3.70687 3.03102 3.59361C3.03102 3.48036 2.93922 3.38854 2.82594 3.38854C2.37671 3.38854 1.84698 3.38854 1.58655 3.38854C1.29113 3.38854 1.05078 3.14818 1.05078 2.85276C1.05078 2.55734 1.29113 2.31699 1.58655 2.31699H11.9426C12.238 2.31699 12.4784 2.55734 12.4784 2.85276C12.4784 3.14818 12.238 3.38854 11.9426 3.38854C11.6241 3.38854 4.474 3.38854 3.78524 3.38854C3.67195 3.38854 3.58016 3.48036 3.58016 3.59361C3.58016 3.70687 3.67195 3.79869 3.78524 3.79869H11.3104L10.7332 10.6402C10.7237 10.7531 10.8075 10.8523 10.9203 10.8618C10.9262 10.8623 10.932 10.8626 10.9378 10.8626C11.0433 10.8626 11.1329 10.7817 11.1419 10.6747L11.7221 3.79869H11.9426C12.4642 3.79869 12.8886 3.37434 12.8886 2.85276C12.8886 2.33118 12.4642 1.90683 11.9426 1.90683ZM8.30757 1.90683H5.22161V1.18602C5.22161 0.936184 5.42488 0.73291 5.67472 0.73291H7.85443C8.10429 0.73291 8.30754 0.936184 8.30754 1.18602V1.90683H8.30757Z" fill="#484848"></path>
                                    </svg>
                                </button>
                            </li>
                        {{/each}}
                    </ul>
                </div>
            </div>
        {{/if}}

            `;

        let res = Sqrl.render(myTemp, {
            c: cart
        });
        tar?tar.innerHTML = res:false;
        let count = cart.item_count;
        count>1?count = count + ' items': count = count + ' item';
        
        document.querySelector('.summary span').innerHTML = count;
        document.querySelector('.subtotal span').innerHTML = currency + (cart.items_subtotal_price / 100);
        document.querySelector('.total span').innerHTML = currency + (cart.total_price / 100);
        setCounter(cart);     
        productHandle();
    }
    

    function basketHandle() {
        const openBtn = document.querySelector('.js-open-cart');
        const closeBtn = document.querySelector('.js-close-cart');
        const mainBasket = document.querySelector('.cart-popup');
        const miniBasket = document.querySelector('.basket');

        document.addEventListener('click', (e) => {
            if (mainBasket.classList.contains('cart-popup--visible') && !e.target.closest('.cart-popup') && !e.target.closest('.js-open-cart')) {
                mainBasket.classList.remove('cart-popup--visible');
            }
        });


        if (openBtn) {
            openBtn.addEventListener('click', (e) => {
              e.preventDefault();

              mainBasket.classList.add('cart-popup--visible');
              miniBasket.classList.remove('active');
            });
        }
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.preventDefault();

              mainBasket.classList.remove('cart-popup--visible');
            });
        }
        

        miniBasket.addEventListener('click', (e) => {
            e.preventDefault();
            if (e.target.type === 'submit') {
                const buttons = miniBasket.querySelectorAll('[type="submit"]');
                buttons.forEach(function(button, index) {
                  if (button === e.target) {
                    const lineIndex = index+1;
                    deleteItem(lineIndex);
                  }
                });
            }
        });
    }
}